import { Typography, Box, Grid, Stack } from "@mui/material";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";

export default function AppVersionSettings({ rawData }) {
  if (!rawData) {
    return (
      <Typography color="error" variant="body2">
        Invalid or empty JSON data
      </Typography>
    );
  }
  const iosSettings = rawData.filter(item => item.platform === 'ios');
  const androidSettings = rawData.filter(item => item.platform === 'android');
  console.log("iOS Settings:", iosSettings);
  console.log("Android Settings:", androidSettings);
  return (
    <Stack spacing={1} sx={{ p: 0, flex: 1, justifyContent: 'center' }}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 1.5,
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <AppleIcon sx={{ fontSize: '1.5rem', mr: 0.5, color: 'text.secondary' }} />
              <Typography variant="h6" sx={{
                color: 'text.secondary',
                fontSize: '0.7rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}>
                iOS
              </Typography>
            </Box>
            <Typography variant="subtitle1" sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '0.8rem',
              mb: 0.5,
            }}>
              {iosSettings.length > 0 ? `v${String(iosSettings[0].latest_version)}` : "N/A"}
            </Typography>
            <Typography variant="body2" sx={{
              fontWeight: 600,
              color: 'text.secondary',
              fontSize: '0.7rem',
            }}>
              Force update: {iosSettings.length > 0 ? `${String(iosSettings[0].force_update)}` : "N/A"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 1.5,
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <AndroidIcon sx={{ fontSize: '1.5rem', mr: 0.5, color: 'success.dark' }} />
              <Typography variant="h6" sx={{
                color: 'text.secondary',
                fontSize: '0.7rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}>
                Android
              </Typography>
            </Box>
            <Typography variant="subtitle1" sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '0.8rem',
              mb: 0.5,
            }}>
              {androidSettings.length > 0 ? `v${String(androidSettings[0].latest_version)}` : "N/A"}
            </Typography>
            <Typography variant="body2" sx={{
              fontWeight: 600,
              color: 'text.secondary',
              fontSize: '0.7rem',
            }}>
              Force update: {androidSettings.length > 0 ? `${String(androidSettings[0].force_update)}` : "N/A"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  )
}
